import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'dashboard_mrh.mes_contracts.title',
  },
  que_faire_en_cas_sinistre: {
    id: 'dashboard_mrh.que_faire_en_cas_sinistre',
  },
  title_contracts_garanties: {
    id: 'dashboard_auto.title_contracts_garanties',
  },
  title_ajout_contrat: {
    id: 'dashboard_auto.title_ajout_contrat',
  },
  declareSinistreTitle: {
    id: 'dashboard_mrh.declare_sinistre_title',
  },
  possibilitiesDeclareSinistre: {
    id: 'dashboard_mrh.possibilities_declare_sinistre',
  },
  declareSinistrePhone: {
    id: 'dashboard_mrh.declare_sinistre_phone',
  },
  declareSinistreAgent: {
    id: 'dashboard_mrh.declare_sinistre_agent',
  },
  EnSavoirPlus: {
    id: 'auto_details_page.compensation_services.find_out_more',
  },
  myServices: {
    id: 'dashboard_auto.my_services',
  },
  contactAgent: {
    id: 'dashboard_auto.contact_agent',
  },
  Actif: {
    id: 'dashboard_auto.mes_contracts.actif',
  },
  Encours: {
    id: 'dashboard_auto.mes_contracts.encours',
  },
  Suivre_sinitre: {
    id: 'dashboard_mrh.title_suivre_sinistre',
  },
  VoirDetail: {
    id: 'dashboard_auto.mes_contracts.voir_tous',
  },
});
